module.exports = __webpack_public_path__ + "img/option-1.26987746.png";